import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LangRouterService } from '@frontend/util-router-history';
import { Router } from '@angular/router';
import { DocumentDetailsService } from '../service/document-details.service';
import * as DocumentDetailsActions from './document-details.actions';
import { isDocumentDetailsRedirectResponse } from './document-details.models';
import { catchError, map, of, switchMap, tap } from 'rxjs';

@Injectable()
export class DocumentDetailsEffects {
  private actions$ = inject(Actions);
  private documentDetailsService = inject(DocumentDetailsService);
  private router = inject(Router);
  private langRouterService = inject(LangRouterService);

  loadDocumentDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentDetailsActions.initDocumentDetails),
      switchMap(({ categoryId, documentId, language, docuLanguage }) => {
        return this.documentDetailsService.getDocumentDetails(categoryId, documentId, language).pipe(
          map((response) => {
            // 301 case: document exists but belongs to a different category_ids[0] -> redirect instead of showing it
            if (isDocumentDetailsRedirectResponse(response)) {
              return DocumentDetailsActions.redirectDocumentDetails({
                categoryId: response.category_ids[0],
                documentId: response.document_id,
                language,
                docuLanguage,
              });
            }
            return DocumentDetailsActions.loadDocumentDetailsSuccess({ documentDetails: response });
          }),
          catchError((error) => {
            console.error('API Error:', error);
            return of(DocumentDetailsActions.loadDocumentDetailsFailure({ error: error.message }));
          }),
        );
      }),
    ),
  );

  // 301 case: navigates to the corrected category URL; the route resolver re-dispatches initDocumentDetails (path param change)
  redirectDocumentDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DocumentDetailsActions.redirectDocumentDetails),
        tap(({ categoryId, documentId, docuLanguage }) => {
          const segments = [this.langRouterService.translateRoute('/categories'), categoryId, 'documents', documentId];
          if (docuLanguage) {
            segments.push(docuLanguage);
          }
          this.router.navigate(segments, { replaceUrl: true });
        }),
      ),
    { dispatch: false },
  );
}
